import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AppData } from '@app/shared/models/appdata.model';
import { VendorSubsidyRequest, VendorSubsidyResponse } from '../models/trade-in-product.model';
import { Observable } from 'rxjs';
import { ClaimCampaignVoucherRequest, CampaignVoucherDTO, ValidateCampaignVoucherRequest } from '../models/voucher.model';

@Injectable({
  providedIn: 'root',
})
export class VoucherService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  apiUrl = this.appData.apiUrl + '/api/v1';

  createOrUpdateVendorSubsidyVoucher(vendorSubsidyRequest: VendorSubsidyRequest): Observable<VendorSubsidyResponse> {
    const apiUrl = `${this.apiUrl}/vouchers/vendorSubsidy/vendorSubsidy`;
    return this.http.post<VendorSubsidyResponse>(apiUrl, vendorSubsidyRequest);
  }

  claimCampaignVoucher(claimCampaignVoucherRequest: ClaimCampaignVoucherRequest): Observable<CampaignVoucherDTO> {
    const apiUrl = `${this.apiUrl}/vouchers/campaigns/claim`;
    return this.http.post<CampaignVoucherDTO>(apiUrl, claimCampaignVoucherRequest);
  }

  validateCampaignVoucher(
    voucherId: string,
    validateCampaignVoucherRequest: ValidateCampaignVoucherRequest
  ): Observable<CampaignVoucherDTO> {
    const apiUrl = `${this.apiUrl}/vouchers/campaigns/${voucherId}/validate`;
    return this.http.put<CampaignVoucherDTO>(apiUrl, validateCampaignVoucherRequest);
  }
}
